import { Form, FormInstance, Row } from "antd";
import { SidePanel } from "./SidePanel";
import { PaymentForm } from "../../../../../../../AdminPayment/components/PaymentForm";
import { Header } from "./Header";
import { useFetchRecord } from "../../hooks/useFetchRecord";
import { useSetPayment } from "../../../../../../../AdminPayment/components/PaymentForm/hooks/useSetPayment";
import { useCallback, useEffect, useState } from "react";
import { useCalculate } from "../../hooks/useCalculate";
import { Loader } from "../../../../../../../../components/Loader";

type TPaymentRecordsProps = {
  accountNumber: number;
  back: () => void;
  paymentId: string | null;
  reloadData: () => void;
  contractId: string;
  openEditMode: boolean;
  setOpenEditMode: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PaymentRecord = ({
  accountNumber,
  back,
  paymentId,
  reloadData,
  contractId,
  openEditMode,
  setOpenEditMode,
}: TPaymentRecordsProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const [instance, setInstance] = useState<any>(null);

  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const [isPaymentEdited, setIsPaymentEdited] = useState<boolean>(openEditMode);

  const { isLoading, initialData, setInitialData, headerData } = useFetchRecord(
    { id: paymentId, contractId, form },
  );

  const { setForm } = useSetPayment(form, setInstance, setInitialData);

  const setInitialForm = useCallback(() => {
    setForm(initialData?.payment, false);
  }, [initialData, setForm]);

  const { calculate, isLCManualyChanged, setIsLCManualyChanged } = useCalculate(
    form,
    instance,
    contractId,
    setIsDisabled,
    setForm,
  );

  useEffect(() => setInitialForm(), [setInitialForm]);

  useEffect(() => {
    if (openEditMode && !isPaymentEdited) {
      setIsPaymentEdited(true);
    }
  }, [isPaymentEdited, openEditMode]);

  return (
    <Row className="position-absolute payment-history-record">
      <Header
        back={back}
        data={headerData}
        isLoading={isLoading}
        reloadData={reloadData}
        paymentId={paymentId}
        setIsPaymentEdited={setIsPaymentEdited}
        isPaymentEdited={isPaymentEdited}
        form={form}
        setIsDisabled={setIsDisabled}
        isDisabled={isDisabled}
        instance={instance}
        setInitialForm={setInitialForm}
        setOpenEditMode={setOpenEditMode}
        contractId={contractId}
        isLCManualyChanged={isLCManualyChanged}
        setIsLCManualyChanged={setIsLCManualyChanged}
      />
      <Row className="w-100 payment-history-record-body-wrapper overflow-y-auto">
        <Row className="d-flex payment-history-record-body pb-4 justify-center">
          {isPaymentEdited && isLoading ? (
            <Loader fontSize="64px" />
          ) : (
            <>
              <SidePanel
                contractId={contractId}
                accountNumber={accountNumber}
                instance={instance}
                isPaymentEdited={isPaymentEdited}
                form={form}
                isDisabled={isDisabled}
                paymentId={paymentId}
              />
              <PaymentForm
                isLoading={isLoading || isDisabled}
                isFormBlured
                instance={instance}
                form={form}
                isPaymentPosted={!isPaymentEdited}
                calculate={calculate}
                isHistoryOpened
                isHistoryEdited={isPaymentEdited}
              />
            </>
          )}
        </Row>
      </Row>
    </Row>
  );
};
